import { UPDATE_WEIGHT_DISPUTE_SUCCESS, UPDATE_WEIGHT_DISPUTE_REQUEST, UPDATE_WEIGHT_DISPUTE_FAILURE, UPDATE_WEIGHT_DISPUTE_RESET, } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const updateWeightDisputeReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_WEIGHT_DISPUTE_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case UPDATE_WEIGHT_DISPUTE_REQUEST:
            return Object.assign({}, state);
        case UPDATE_WEIGHT_DISPUTE_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case UPDATE_WEIGHT_DISPUTE_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, data: null });
        default:
            return state;
    }
};
export default updateWeightDisputeReducer;
